import React from 'react'
import { useSelector } from 'react-redux'
import getUrl from 'front-end-core/core/url'
import { LEGISLATION } from 'constants/controllers'
import cx from 'classnames'
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp'
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown'
import ListItemContainer from 'redux/containers/pages/legislationcategories/ListItemContainer'
import selectAolName from 'redux/selectors/selectAolName'

const SectionHeader = ({ title, toggle, expanded, sectionId }) => toggle
  ? (
    <a
      href={null}
      className={cx(
        'h3 pv5 pl6 pr6 ma0 bb db flex items-center justify-between hover-gains-boro',
        'bg-dark-orchid white f5 fw6 pointer hover-no-underline font-reset-fix'
      )}
      onClick={toggle}
      data-event-action={!expanded ? 'Collapse' : 'Expand'}
      data-event-category='Legislation Folders'
      data-event-label={`${sectionId}: ${title}`}
    >
      <span>
        {title}
      </span>
      <span className='white pr2'>
        {expanded ? <KeyboardArrowUp className='w8 h-auto vm' /> : <KeyboardArrowDown className='w8 h-auto vm' />}
      </span>
    </a>
    )
  : (
    <div>
      {title}
    </div>
    )

const List = ({ childrenList, expanded, toggleExpandedSection, sectionId, name, count }) => {
  if (!expanded && toggleExpandedSection) {
    return null
  }

  if (count.length === 0) {
    return (
      <ul className='list-reset pa0'>
        <li>
          <div className='h3 bb b--black fw6 f5 pl6 flex flex-column justify-center items-start ma0'>No legislation to show</div>
        </li>
      </ul>
    )
  }

  return (
    <ul className='list-reset pa0'>
      {childrenList.map(legislation => (
        <ListItemContainer key={legislation.id} {...{ legislation, sectionId, name }} />
      ))}
    </ul>
  )
}

const Heading = ({ id, name, children, expanded, toggleExpandedSection, sectionId }) => {
  const aol = useSelector(selectAolName)

  return (
    <li id={getUrl(LEGISLATION, { aol, path: id })} className='w-100'>
      <SectionHeader
        toggle={toggleExpandedSection && (() => toggleExpandedSection(id))}
        title={name}
        expanded={expanded}
        sectionId={sectionId}
      />
      <List {...{ childrenList: children, expanded, toggleExpandedSection, sectionId, name, count: children.filter(c => c.hidden === false).length }} />
    </li>
  )
}

export default Heading
